export const CODE_INSIGHTS_REPORTS_PAGE_SIZE = 10;
export const CODE_INSIGHTS_ANNOTATIONS_PAGE_SIZE = 100;
